// The "Championship DNA" link in the coach nav.
//
// Who sees it mirrors who DNA lets in (core/packs/championship_dna/auth.py): a `coach` holding the football entitlement, and a
// `platform_admin`.  The sign-in token's `authoring_domains` lists the coach's active entitlements, so `football` there is the entitlement.
// DNA still checks on every request; this only decides whether the link is worth showing.
//
// Where it points: DNA is served at /week/ on the MAIN host (dev-1.example), not on learn.<host> or coach.<host>, so from either of those
// the link goes to the same environment's parent host; anywhere else (already the main host, local dev) it stays relative.

export const DNA_PATH = '/week/';
export const DNA_DOMAIN = 'football';
export const DNA_ROLE = 'coach';

export function canSeeDnaLink(learner) {
  if (!learner) return false;
  if (learner.role === 'platform_admin') return true;
  const domains = Array.isArray(learner.authoring_domains) ? learner.authoring_domains : [];
  return learner.role === DNA_ROLE && domains.includes(DNA_DOMAIN);
}

export function dnaHref(hostname, protocol = 'https:') {
  const m = /^(?:learn|coach)\.(.+)$/i.exec(String(hostname || ''));
  return m ? `${protocol}//${m[1]}${DNA_PATH}` : DNA_PATH;
}
